import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-it",
  "use": "icon-flag-it-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-it\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 860.16h348.16V163.84H0z\" fill=\"#009246\" p-id=\"6702\" /><path d=\"M348.16 860.16h348.16V163.84H348.16z\" fill=\"#FFFFFF\" p-id=\"6703\" /><path d=\"M675.84 860.16h348.16V163.84H675.84z\" fill=\"#CE2B37\" p-id=\"6704\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-it.svg
// module id = HgeY
// module chunks = 24